import logo from "./asset/images/logo.png";
import iphone from "./asset/images/header-iphone.png";
import featuresiphone1 from "./asset/images/features-iphone-1.png";
import videoframe from "./asset/images/video-frame.jpg";
import Morphext from "./asset/js/morphext";
import { useEffect, useState } from "react";

function App() {
  const [flagValue, setFlagValue] = useState({ navbarExpanded: false, spinner: false, backToTop: false, collapse1: false, collapse2: false });
  const phrases = ["طلافروشان", "بازاریابان", "معامله‌گران"];

  useEffect(() => {
    setTimeout(function () {
      setFlagValue((flagValue) => ({ ...flagValue, spinner: true }));
    }, 1000);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 20) {
        setFlagValue((flagValue) => ({ ...flagValue, navbarExpanded: true }));
      } else {
        setFlagValue((flagValue) => ({ ...flagValue, navbarExpanded: false }));
      }
    });
  }, []);

  window.onscroll = function () {
    if (document.documentElement.scrollTop > 600) {
      setFlagValue((flagValue) => ({ ...flagValue, backToTop: true }));
    } else {
      setFlagValue((flagValue) => ({ ...flagValue, backToTop: false }));
    }
  };
  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  function refNavClick(event) {
    setFlagValue((flagValue) => ({ ...flagValue, collapse2: !flagValue.collapse2 }));
  }

  function ParentNavClick(event) {
    setFlagValue((flagValue) => ({ ...flagValue, collapse1: !flagValue.collapse1 }));
  }

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    let deferredPrompt = e;
    const addbtn = document.getElementById("install_banner1");
    if (addbtn !== null) addbtn.style.display = "block";

    addbtn.addEventListener("click", (e) => {
      addbtn.style.display = "none";
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        // if (choiceResult.outcome === "accepted") {
        //   console.log("User accepted the A2HS prompt");
        // } else {
        //   console.log("User dismissed the A2HS prompt");
        // }
        deferredPrompt = null;
      });
    });
  });

  return (
    <>
      <a id="backToTop" className="back-to-top page-scroll" onClick={topFunction} style={{ display: flagValue.backToTop ? "inline" : "none" }}>
        Back to Top
      </a>
      <div className={`spinner-wrapper${flagValue.spinner ? " d-none" : ""}`}>
        <div className="spinner">
          <div className="bounce1"></div>
          <div className="bounce2"></div>
          <div className="bounce3"></div>
        </div>
      </div>
      <nav id="navbarMain" className={`navbar navbar-expand-md navbar-dark navbar-custom fixed-top${flagValue.navbarExpanded ? " top-nav-collapse" : ""}`}>
        <a className="navbar-brand logo-image" href="index.html">
          <img src={logo} alt="alternative" />
        </a>
        <div className="card-icon" id="install_banner1" title="نصب برنامه" style={{display:"none", cursor: "pointer", color: "white", backgroundColor: "transparent", position: "absolute", top: "5px", left: "20px", ":hover": "darkblue !important" }}>
          <i className="far fa-file-code" style={{ position: "absolute", top: "12px", width: "56px", left: "10px" }}></i>
          <span style={{ position: "absolute", top: "22px", width: "56px", left: "-10px" }}>نصب برنامه</span>
        </div>
        <button
          className={`navbar-toggler ${!flagValue.collapse1 ? "collapsed" : ""}`}
          type="button"
          data-toggle="collapse"
          data-target="#navbarsExampleDefault"
          aria-controls="navbarsExampleDefault"
          aria-expanded={flagValue.collapse2 ? true : false}
          aria-label="Toggle navigation"
          onClick={ParentNavClick}
        >
          <i className="navbar-toggler-awesome fas fa-bars"></i>
          <i className="navbar-toggler-awesome fas fa-times"></i>
        </button>
        <div className={`navbar-collapse collapse ${flagValue.collapse2 ? "show" : ""}`} id="navbarsExampleDefault">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a className="nav-link page-scroll" href="#contact" onClick={refNavClick}>
                تماس با ما
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link page-scroll" href="#preview" onClick={refNavClick}>
                پیش نمایش
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link page-scroll" href="#features" onClick={refNavClick}>
                ویژگی ها
              </a>
            </li>

            <li className="nav-item">
              <a className="nav-link page-scroll" href="#header" onClick={(event) => refNavClick(event)}>
                خانه <span className="sr-only">(current)</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
      <header id="header" className="header">
        <div className="header-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="text-container text-right">
                  <h1 style={{ marginBottom: "30px" }}>
                    سامانه هوشمند اُگمی
                    <br />
                  </h1>
                  <h1>
                    <span>برنامه ای </span>
                    <span>برای </span>
                    <span>
                      <Morphext animation="flipInX" speed="3000" phrases={phrases} />
                    </span>
                    {/* <span id="js-rotating"</span> */}
                  </h1>
                  <p className="p-large">سامانه هوشمند اُگمی، برنامه ای جهت معامله انواع مصنوعات طلا انواع آبشده ها می باشد که توسط معامله گران بزرگ بازار طلا پشتیبانی می‌شود </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="image-container">
                  <img className="img-fluid" src={iphone} alt="alternative" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div id="features" className="tabs">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2>ویژگی‌های اُگمی</h2>
              <div className="p-heading p-large">سامانه هوشمند اُگمی دارای ویژگی های منحصربفردی می باشد که برخی از این ویژگی ها را شرح می دهیم </div>
            </div>
          </div>
          <div className="row">
            <ul className="nav nav-tabs" id="lenoTabs" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" id="nav-tab-1" data-toggle="tab" href="#tab-1" role="tab" aria-controls="tab-1" aria-selected="true">
                  <i className="fas fa-cog"></i>تنظیمات
                </a>
              </li>
            </ul>
            <div className="tab-content" id="lenoTabsContent">
              <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab-1">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="card left-pane first">
                        <div className="card-body">
                          <div className="text-wrapper">
                            <h4 className="card-title">فناوری</h4>
                            <p style={{ direction: "rtl" }}>بالاترین سطح دانش برنامه نویسی SPA با بروزترین و قدرتمندترین فریمورک WebApplication دنیا </p>
                          </div>
                          <div className="card-icon">
                            <i className="far fa-compass"></i>
                          </div>
                        </div>
                      </div>
                      <div className="card left-pane">
                        <div className="card-body">
                          <div className="text-wrapper">
                            <h4 className="card-title">امنیت</h4>
                            <p>بهره‌گیری از سیستم پیاده سازی چند لایه، فایروال های قدرتمند سخت افزاری و نرم افزاری جهت پایداری سامانه</p>
                          </div>
                          <div className="card-icon">
                            <i className="far fa-file-code"></i>
                          </div>
                        </div>
                      </div>
                      <div className="card left-pane">
                        <div className="card-body">
                          <div className="text-wrapper">
                            <h4 className="card-title">نمودار</h4>
                            <p>دارای نمودارهای تجزیه و تحلیل مظنه به روز،هفته و ماه</p>
                          </div>
                          <div className="card-icon">
                            <i className="far fa-chart-bar"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <img className="img-fluid" src={featuresiphone1} alt="alternative" />
                    </div>
                    <div className="col-lg-4">
                      <div className="card right-pane first">
                        <div className="card-body right">
                          <div className="card-icon">
                            <i className="far fa-money-bill-alt"></i>
                          </div>
                          <div className="text-wrapper">
                            <h4 className="card-title">ثبت مظنه</h4>
                            <p>امکان ثبت لحظه ای مظنه انواع مسکوکات طلا و آبشده</p>
                          </div>
                        </div>
                      </div>
                      <div className="card right-pane">
                        <div className="card-body right">
                          <div className="card-icon">
                            <i className="far fa-registered"></i>
                          </div>
                          <div className="text-wrapper">
                            <h4 className="card-title">تغییرات لحظه ای</h4>
                            <p>اعمال تغییرات مظنه بصورت لحظه ای برای تمامی مشتریان با فناوری SignalR</p>
                          </div>
                        </div>
                      </div>
                      <div className="card right-pane">
                        <div className="card-body right">
                          <div className="card-icon">
                            <i className="far fa-handshake"></i>
                          </div>
                          <div className="text-wrapper">
                            <h4 className="card-title">معامله خرید و فروش</h4>
                            <p>معامله خرید و فروش آنلاین انواع مسکوکات و آبشده ها در سایت بین خریدار و فروشنده و رصد لحظه ای و دائم معامله </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="preview" className="basic-1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2>پیش نمایش</h2>
              <div className="p-heading p-large">سامانه هوشمند اُگمی، امکان معامله انواه مسکوکات طلا و آبشده را بین خریدار و فروشنده برقرار می نماید. رصد معامله انجام شده یا تایید نشده در هر دو سمت خریدار و فروشنده امکان پذیر می باشد</div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="image-container">
                <div className="video-wrapper">
                  <a className="popup-youtube" href="#" data-effect="fadeIn">
                    <img className="img-fluid" src={videoframe} alt="alternative" />
                    <span className="video-play-button">
                      <span></span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="contact" className="form">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2>تماس با ما</h2>
              <ul className="list-unstyled li-space-lg contact" style={{ direction: "rtl" }}>
                <li className="address">برای ارتباط با ما جهت مشاوره و خرید سامانه هوشمند معاملات طلای اٌگمی می توانید فرم زیر را تکمیل و ارسال نمایید</li>
                <li className="address">کارشناسان ما در اسرع وقت با شما تماس خواهند گرفت</li>
                <li>
                  <i className="fas fa-map-marker-alt"></i>ایران -- یزد --- طلای اٌگمی
                </li>
                <li>
                  <i className="fas fa-phone"></i>
                  <a className="blue" href="tel:003024630820">
                    +35 222 22222
                  </a>
                </li>
                <li>
                  <i className="fas fa-envelope"></i>
                  <a className="blue" href="mailto:office@leno.com">
                    info@ogmi.ir
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <form id="contactForm" data-toggle="validator" data-focus="false">
                <div className="form-group">
                  <input type="text" className="form-control-input" id="cname" required />
                  <label className="label-control " htmlFor="cname">
                    نام
                  </label>
                  <div className="help-block with-errors"></div>
                </div>
                <div className="form-group">
                  <input type="email" className="form-control-input" id="cemail" required />
                  <label className="label-control" htmlFor="cemail">
                    ایمیل
                  </label>
                  <div className="help-block with-errors"></div>
                </div>
                <div className="form-group">
                  <textarea className="form-control-textarea" id="cmessage" required></textarea>
                  <label className="label-control" htmlFor="cmessage">
                    پیام خود را بنویسید
                  </label>
                  <div className="help-block with-errors"></div>
                </div>

                <div className="form-group">
                  <button type="submit" className="form-control-submit-button">
                    ارسال پیام
                  </button>
                </div>
                <div className="form-message">
                  <div id="cmsgSubmit" className="h3 text-center hidden"></div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="footer-col">
                <h4> درباره OGMI</h4>
                <p>OGMI مخفف عبارت Online Gold Market Iran به معنای بازار آنلاین طلای ایران می باشد. در این بازار معاملات انواع مسکوکات طلا و آبشده ها انجام می پذیرد</p>
              </div>
            </div>
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <div className="footer-col last">
                <h4>شبکه های اجتماعی</h4>
                <span className="fa-stack">
                  <a href="#your-link">
                    <i className="fas fa-circle fa-stack-2x"></i>
                    <i className="fab fa-facebook-f fa-stack-1x"></i>
                  </a>
                </span>
                <span className="fa-stack">
                  <a href="#your-link">
                    <i className="fas fa-circle fa-stack-2x"></i>
                    <i className="fab fa-twitter fa-stack-1x"></i>
                  </a>
                </span>
                <span className="fa-stack">
                  <a href="#your-link">
                    <i className="fas fa-circle fa-stack-2x"></i>
                    <i className="fab fa-google-plus-g fa-stack-1x"></i>
                  </a>
                </span>
                <span className="fa-stack">
                  <a href="#your-link">
                    <i className="fas fa-circle fa-stack-2x"></i>
                    <i className="fab fa-instagram fa-stack-1x"></i>
                  </a>
                </span>
                <span className="fa-stack">
                  <a href="#your-link">
                    <i className="fas fa-circle fa-stack-2x"></i>
                    <i className="fab fa-linkedin-in fa-stack-1x"></i>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <p className="p-small">کپی رایت © Ogmi.ir</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
